module.exports = __webpack_public_path__ + "static/media/10.8b60b404.jpg";